<script setup>
import { TransitionRoot, TransitionChild, Dialog, DialogPanel } from '@headlessui/vue'
import { useModal } from 'momentum-modal'
import CloseSvg from '@svg/new-close.svg'

const { redirect } = useModal()

defineProps({
    show: {
        type: Boolean,
        default: false
    },
    initialFocus: Object
})

const emit = defineEmits()
</script>

<template>
<TransitionRoot appear as="template" :show="show">
    <Dialog :initialFocus="initialFocus" as="div" class="relative z-50" v-on:close="emit('close')">
        <TransitionChild
            v-on:after-leave="redirect"
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="duration-300 ease-out"
            leave-from="opacity-100"
            leave-to="opacity-0">
            <div class="fixed inset-0 backdrop-blur-sm bg-[rgba(0,0,0,0.6)] transition-opacity" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild
                as="template"
                enter="transition duration-300 ease-out"
                enter-from="opacity-0 -translate-y-3"
                enter-to="opacity-100"
                leave="transition duration-300 ease-out"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <DialogPanel dusk="modal" v-bind="$attrs" class="relative w-full transform overflow-hidden rounded-2xl text-left align-middle shadow-xl transition-all">
                    <slot />
                    <div class="absolute px-4 py-5 top-0 w-full flex items-center justify-end">
                        <button class="size-6 flex items-center justify-center touch-manipulation" v-on:click="emit('close')">
                            <CloseSvg class="size-6 text-[rgba(132,156,241,1)] touch-manipulation" />
                        </button>
                    </div>
                </DialogPanel>
            </TransitionChild>
            </div>
        </div>
    </Dialog>
</TransitionRoot>
</template>
